import { Company, Id } from "@/models"
import { ApiService } from "@/services"

export class CompaniesService extends ApiService {
	constructor() {
		super("/api/companies")
	}

	async list() {
		return await this.returning(Company.array()).get("")
	}

	async create(company: Company) {
		return await this.returning(Company).post("", company)
	}

	async update(company: Company) {
		return await this.returning(Company).put("", company)
	}

	async delete(companyId: Id) {
		return await this.returningVoid().delete(String(companyId))
	}
}
